<script lang="ts" setup>
  import { useQuery } from '@pinia/colada';
  import { computed } from 'vue';
  import { gameInProgressQuery } from '../../../shared/api/gameInProgress.ts';
  import GameInfoView from './GameInfoView.vue';

  const props = defineProps<{ gameCode: string }>();

  const { data: isOpen } = useQuery(() => gameInProgressQuery(Number(props.gameCode)));
  const joinability = computed(() => (isOpen.value === undefined ? 'unknown' : isOpen.value ? 'open' : 'closed'));
</script>

<template>
  <GameInfoView :game-code="gameCode" :joinability="joinability" />
</template>
